import React, { useEffect } from "react";
import MiniHero from "./../MiniHero";

function ComplaintsProcedures({ homeRef, handleScroll }) {
  useEffect(() => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0;
  }, []);
  return (
    <>
      <MiniHero
        homeRef={homeRef}
        onScroll={handleScroll}
        title="Complaints procedure"
        className="fs-48 text-dark mb-5"
      />
      <div className="container py-5">
        <div className="max-width-720 mx-auto">
          <p>
            Tanaad Money Ltd is committed to delivering an efficient and
            professional service. We aim to provide prompt, courteous, helpful,
            open and informative advice in response to every approach made by a
            member of public. We are always keen to hear the views of our
            customers, particularly the public, about our performance generally.
          </p>
          <p>
            We recognize that, like all organizations, from time to time things
            may go wrong. We are especially keen to hear about such instances
            since they provide us with an opportunity to put things right and to
            learn from our mistakes.
          </p>
          <h3 className="fs-2">How to make a complaint</h3>
          <p>
            You can make a complaint in writing by letter, email or by
            telephone.
          </p>
          <p>
            Complaints should normally be directed to the member of staff with
            whom you have been dealing or our Complaints manager. This will give
            them the opportunity to explain what actions have been taken and to
            try to sort things out with you. If you would prefer, you can ask
            the member of staff for the name of their line manager and send your
            complaint to them or directly to our Complaints manager.
          </p>
          <h3 className="fs-2">What happens next?</h3>
          <p>
            We will use our best endeavours to treat complaints thoroughly,
            fairly and politely, and investigate them sensitively and respond
            promptly.
          </p>
          <p>
            Our target for replying to complaints is 15 business days from the
            date of receipt. If it is not possible to give you a full reply
            within this time – for instance because detailed investigation is
            required – we will give you an interim response, telling you what is
            being done to deal with your complaint, and when you can expect the
            full reply and from whom.
          </p>
          <p>Our Complaints manager can be contacted:</p>
          <h3 className="fs-4">By Post:</h3>
          <div>
            <p className="mb-0">5 Red Lion Court,</p>
            <p className="mb-0">Alexandra Road,</p>
            <p className="mb-0">Hounslow, England,</p>
            <p className="mb-0">TW3 1JS</p>
          </div>
          <h3 className="fs-4">By Telephone:</h3>
          <div>
            <a href="tel: 0203 070 3009">0203 070 3009</a>
          </div>
          <p className="mt-3">OR</p>
          <div>
            <h3 className="fs-4">By Email:</h3>
            <div>
              <a href="mailto: support@tanaad.com">support@tanaad.com</a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ComplaintsProcedures;
